import { c as _c } from "react/compiler-runtime";
import { Stack, type SxProps, Typography } from '@mui/material';
import { useId } from 'react';
import type { DesktopFilterOptions } from '../hooks/useDesktopFilterOptions';
import { CardFeaturesFilter } from './Filters/CardFeatures';
import { CreditRangeFilter } from './Filters/CreditRange';
import { IssuersFilter } from './Filters/Issuers';
import { SortByFilter } from './Filters/SortBy';
const styles = {
  wrapper: {
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: {
      xs: 'flex-start',
      lg: 'space-between'
    },
    gap: {
      xs: 2,
      lg: 0
    },
    minWidth: 0
  },
  filterStack: {
    flex: {
      xs: '1 1 0',
      lg: '1 1 236px'
    },
    maxWidth: {
      xs: 'none',
      lg: '236px'
    },
    minWidth: 0,
    gap: 2
  },
  filtersGroupStack: {
    gap: 2,
    display: {
      xs: 'contents',
      lg: 'flex'
    },
    flex: {
      lg: '1 1 auto'
    },
    minWidth: 0,
    justifyContent: {
      lg: 'flex-end'
    }
  },
  featuresFilterStack: {
    flex: {
      xs: '1 1 0',
      lg: '0 0 auto'
    },
    minWidth: 0,
    gap: 2
  }
} as const satisfies Record<string, SxProps>;
type FiltersStaticProps = {
  filterOptions: DesktopFilterOptions;
  forceCloseDropdowns?: boolean;
};
export function FiltersStatic(t0) {
  const $ = _c(43);
  const {
    filterOptions,
    forceCloseDropdowns
  } = t0;
  const uniqueId = useId();
  const featuresLabelId = `features-filter-label-${uniqueId}`;
  const creditRangeLabelId = `credit-range-filter-label-${uniqueId}`;
  const issuersLabelId = `issuers-filter-label-${uniqueId}`;
  const sortByLabelId = `sort-by-filter-label-${uniqueId}`;
  let t1;
  if ($[0] !== featuresLabelId) {
    t1 = <Typography id={featuresLabelId} variant="textBold">Filter by</Typography>;
    $[0] = featuresLabelId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== featuresLabelId || $[3] !== filterOptions || $[4] !== forceCloseDropdowns) {
    t2 = <CardFeaturesFilter options={filterOptions} forceClose={forceCloseDropdowns} showPillsOnLarge={true} labelledById={featuresLabelId} />;
    $[2] = featuresLabelId;
    $[3] = filterOptions;
    $[4] = forceCloseDropdowns;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Stack direction="column" sx={styles.featuresFilterStack}>{t1}{t2}</Stack>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== creditRangeLabelId) {
    t4 = <Typography id={creditRangeLabelId} variant="textBold">Credit range</Typography>;
    $[9] = creditRangeLabelId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== creditRangeLabelId || $[12] !== filterOptions || $[13] !== forceCloseDropdowns) {
    t5 = <CreditRangeFilter labelledById={creditRangeLabelId} options={filterOptions} forceClose={forceCloseDropdowns} />;
    $[11] = creditRangeLabelId;
    $[12] = filterOptions;
    $[13] = forceCloseDropdowns;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <Stack direction="column" sx={styles.filterStack}>{t4}{t5}</Stack>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== issuersLabelId) {
    t7 = <Typography id={issuersLabelId} variant="textBold">Issuers</Typography>;
    $[18] = issuersLabelId;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== filterOptions || $[21] !== forceCloseDropdowns || $[22] !== issuersLabelId) {
    t8 = <IssuersFilter labelledById={issuersLabelId} options={filterOptions} forceClose={forceCloseDropdowns} />;
    $[20] = filterOptions;
    $[21] = forceCloseDropdowns;
    $[22] = issuersLabelId;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <Stack direction="column" sx={styles.filterStack}>{t7}{t8}</Stack>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== sortByLabelId) {
    t10 = <Typography id={sortByLabelId} variant="textBold">Sort by</Typography>;
    $[27] = sortByLabelId;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== filterOptions || $[30] !== forceCloseDropdowns || $[31] !== sortByLabelId) {
    t11 = <SortByFilter labelledById={sortByLabelId} options={filterOptions} forceClose={forceCloseDropdowns} />;
    $[29] = filterOptions;
    $[30] = forceCloseDropdowns;
    $[31] = sortByLabelId;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <Stack direction="column" sx={styles.filterStack}>{t10}{t11}</Stack>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t6 || $[38] !== t9) {
    t13 = <Stack direction="row" sx={styles.filtersGroupStack}>{t6}{t9}{t12}</Stack>;
    $[36] = t12;
    $[37] = t6;
    $[38] = t9;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t13 || $[41] !== t3) {
    t14 = <Stack direction="row" sx={styles.wrapper}>{t3}{t13}</Stack>;
    $[40] = t13;
    $[41] = t3;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}